"use strict";
/**
 * Read and persist sessionId using cookies
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.get = get;
exports.set = set;
exports.anonymizeSessionId = anonymizeSessionId;
var uuid = require("uuid");
var cookie = require("./cookie");
var LOG_COOKIE_NAME = "dojo_log_session_id";
var sessionId = ensureSessionId();
function ensureSessionId() {
    if (cookie.hasOptedOutOfCookies()) {
        if (cookie.hasItem(LOG_COOKIE_NAME)) {
            anonymizeSessionId();
        }
        return "redacted";
    }
    if (cookie.hasItem(LOG_COOKIE_NAME)) {
        return cookie.getItem(LOG_COOKIE_NAME) || "unknown";
    }
    var sessionId = uuid.v4();
    saveSessionIdToCookie(sessionId);
    return sessionId;
}
function saveSessionIdToCookie(sessionId) {
    if (cookie.hasOptedOutOfCookies()) {
        return;
    }
    cookie.setItem(LOG_COOKIE_NAME, sessionId, Infinity, null, "classdojo.com");
}
function get() {
    if (cookie.hasOptedOutOfCookies()) {
        if (cookie.hasItem(LOG_COOKIE_NAME)) {
            anonymizeSessionId();
        }
        return "redacted";
    }
    return sessionId;
}
function set(newId) {
    sessionId = newId || "unknown";
    if (cookie.hasOptedOutOfCookies()) {
        return;
    }
    saveSessionIdToCookie(sessionId);
}
function anonymizeSessionId() {
    cookie.removeItem(LOG_COOKIE_NAME, null, "classdojo.com");
}
//# sourceMappingURL=sessionId.js.map